import React, { useState, useEffect, useRef } from "react";
import { makeStyles, createStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";
import {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
} from "../../../actions/LimsAdminActions";
import { useNavigate, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
import QRCode from "react-qr-code";
import "./style.css";
import logo from "../../../../redcliffe_logo.jpeg";
import nabllogo from "../../../../NABL Logo.png";
import mra from "../../../../mra.png";
// import imagelogo from "./logo_RCL.png";
import DocterSignature from "./prabhakar-signature.png";
import DocterSignature2 from "./nakul-signature.png";
import callIcon from "../../../../callicon.png";
import maillIcon from "../../../../mailicon.png";
import browserIcon from "../../../../browsericon.png";
import { TableBody, colors } from "@mui/material";
import { Image } from "@progress/kendo-drawing/dist/npm/drawing";
import { Paper } from "@mui/material";
import Grid from '@mui/material/Grid';
import graph from "./graph.png";
import { Select, MenuItem, TextField } from '@material-ui/core';
import moment from "moment";
import { Grammarly, GrammarlyEditorPlugin } from "@grammarly/editor-sdk-react";
import NpsRating from "../../NPS";
const useStyles = makeStyles((theme) =>
    createStyles({
        paper: {
            width: "100%",
        },
        centerIt: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        fontWeight: {
            fontWeight: "bold",
        },
        textCenter: {
            textAlign: "center",
        },
        endIt: {
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
        },
        belowIt: {
            display: "flex",
            alignItems: "flex-end",
        },
        line: {
            borderBottom: "5px solid red",
            marginTop: "5px",
            width: "90%",
        },
        inputFiled: {
            outline: "none",
        },
        input: {
            padding: "1px",
            direction: "rtl",
        },
    })
);
interface Props {
    reportListParameter: any;
    getReportTemplateParameter: any;
    bookingId: any;
    reportData: any;
    createNewReport: any;
    updateReport: any;
    getUpdatedCustomerReportData: any;
    updateNiptDob: any;
    createNiptDob: any;
}
const JakReport: React.FC<Props> = ({
    getReportTemplateParameter,
    reportListParameter,
    bookingId,
    reportData,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
}) => {
    const componentRef = useRef<any>(null);
    const { firstP, secondP, thirdP } = useParams<any>();
    const classes = useStyles();
    const navigator = useNavigate();
    const [status, setStatus] = useState<string>(reportListParameter?.status);
    const [dob, setDob] = useState<any>("");
    const [age, setAge] = useState<any>("");
    const [Sample_Received, setSample_Received] = useState<any>("");
    const [Sample_Receivedtime, setSample_Receivedtime] = useState<any>("");
    const [Sample_Collected, setSample_Collected] = useState<any>("");
    const [designation, setdesignation] = useState<any>("");
    const [Name, setName] = useState<any>("");
    const [Gender, setGender] = useState<any>("");
    const [uuid, setUuid] = useState()
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    const reactToPrintTrigger = React.useCallback(() => {
        return (
            <button
                style={{ marginLeft: "10px", background: "#b02613", color: "white" }}
            >
                Print Report
            </button>
        );
    }, []);

    //Report Data
    const [jak, setjak] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setjak(data);
    }, [reportListParameter])


    useEffect(() => {
        if (thirdP !== "add") {
            getUpdatedCustomerReportData(`booking_id=${firstP}&template_id=${secondP}`)
        } else {
            getReportTemplateParameter(`booking_id=${firstP}&template_id=${secondP}`);
        }
    }, [])


    //Booking Data
    const [jakReport, setjakReport] = useState<any>([])
    useEffect(() => {
        const data: any = []
        if (reportListParameter && reportListParameter?.booking && reportListParameter?.booking.length > 0) {
            reportListParameter?.booking?.map((list: any) => {
                data?.push({ ...list });
            })
        }
        setjakReport(data);
    }, [reportListParameter])


    useEffect(() => {
        setSample_Collected(jakReport[0]?.collection_date);
        setSample_Receivedtime(jakReport[0]?.pickup_time);
        setdesignation(jakReport[0]?.designation);
        setGender(jakReport[0]?.customer_gender);
        setSample_Received(jakReport[0]?.pickup_date);
        setName(jakReport[0]?.customer_name);
        setAge(jakReport[0]?.customer_age);
        setDob(jakReport[0]?.dob);
        setUuid(jakReport[0]?.uuid)
    }, [jakReport]);

    useEffect(() => {
        if (dob) {
            const currentDate = new Date();
            const dobDate = new Date(dob);
            const ageInMilliseconds = currentDate.getTime() - dobDate.getTime();
            const ageInYears = Math.floor(ageInMilliseconds / (1000 * 60 * 60 * 24 * 365));
            setAge(ageInYears);

        }
        else {

            setAge(jakReport[0]?.customer_age);
        }
    }, [dob]);

    //Clinical indication
    const [jakClinData, setjakClinData] = useState<any>([]);
    useEffect(() => {
        const bcrclincdata: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_indication &&
            reportListParameter?.clinical_indication?.length > 0
        ) {
            reportListParameter?.clinical_indication?.map((list: any) => {
                bcrclincdata?.push({ ...list });
            });
        }
        setjakClinData(bcrclincdata);
    }, [reportListParameter]);

    const updateClientIndication = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any) => {
        let storeData = [...jakClinData]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value
                break;
        }
        storeData[index] = newItem;
        setjakClinData(storeData);
    }

    // result
    let Data = [
        {
            id: 1,
            name: "Jak-2 (V617F)",
            result: " Not Detected"
        },
    ];
    const [jakResult, setjakResult] = useState([]);

    useEffect(() => {
        let storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            reportListParameter?.result_brca?.map((list: any) => {
                storeData.push({ ...list });
            });
        }
        setjakResult(storeData);
    }, [reportListParameter]);

    const [tableData, setTableData] = useState<any>([]);
    useEffect(() => {
        let data: any,
            parse: any,
            storeData: any = [];
        if (
            reportListParameter &&
            reportListParameter?.result_brca &&
            reportListParameter?.result_brca.length > 0
        ) {
            data = reportListParameter?.result_brca[0]?.parameter_value;
            if (data) {
                parse = JSON.parse(data);
            }
            if (parse?.length > 0) {
                parse?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
            else {
                Data?.map((list: any) => {
                    storeData.push({
                        ...list,
                    });
                });
            }
        }
        setTableData(storeData);
    }, [reportListParameter]);

    const updateRow = (index: number, key: string, value: any, object: any) => {
        let storeData = [...tableData];
        let newItem = storeData[index];
        switch (key) {
            case "name":
                newItem.name = value;
                break;
            case "result":
                newItem.result = value;
                break;

        }
        storeData[index] = newItem;
        setTableData(storeData);
    };

    //clinical Significance

    // const [jakSignificance, setjakSignificance] = useState<any>([]);
    // useEffect(() => {
    //     const data: any = [];
    //     if (
    //         reportListParameter &&
    //         reportListParameter?.clinical_significance
    //         &&
    //         reportListParameter?.clinical_significance
    //             .length > 0
    //     ) {
    //         reportListParameter?.clinical_significance
    //             ?.map((list: any) => {
    //                 data?.push({ ...list });
    //             });
    //     }
    //     setjakSignificance(data);
    // }, [reportListParameter]);

    // const updateSignificance = (id: number, value: any, index: number, key: string, object: any) => {
    //     let storeData = [...jakSignificance]
    //     let newItem = object;
    //     switch (key) {
    //         case "free_text":
    //             newItem.parameter_value = value;
    //             break;
    //     }
    //     storeData[index] = newItem;
    //     setjakSignificance(storeData);
    // }

    //Methodology
    const [jakMethology, setjakMethology] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.methodology &&
            reportListParameter?.methodology.length > 0
        ) {
            reportListParameter?.methodology?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setjakMethology(data);
    }, [reportListParameter]);

    const updateMethology = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...jakMethology]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setjakMethology(storeData);
    }
    //test Details
    const [textDetail, settextDetail] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.test_details &&
            reportListParameter?.test_details.length > 0
        ) {
            reportListParameter?.test_details?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        settextDetail(data);
    }, [reportListParameter]);

    const updatetextDetail = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...textDetail]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        settextDetail(storeData);
    }


    //Limitations of Essay
    const [Limitations, setLimitations] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.test_limitations
            &&
            reportListParameter?.test_limitations
                .length > 0
        ) {
            reportListParameter?.test_limitations
                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setLimitations(data);
    }, [reportListParameter]);

    const updateLimitations = (
        id: number,
        value: any,
        index: number,
        key: string,
        object: any
    ) => {
        let storeData = [...Limitations];
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLimitations(storeData);
    };

    //Hospital name
    const [hospitalName, setHospitalName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.hospital_name &&
            reportListParameter?.hospital_name.length > 0
        ) {
            reportListParameter?.hospital_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setHospitalName(data);
    }, [reportListParameter]);

    const updateHospitalName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...hospitalName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalName(storeData);
    }

    //Clincian Name
    const [clinicianName, setClinicianName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.clinical_name &&
            reportListParameter?.clinical_name.length > 0
        ) {
            reportListParameter?.clinical_name?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setClinicianName(data);
    }, [reportListParameter]);

    const updateClinicanName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...clinicianName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setClinicianName(storeData);
    }

    //Location
    const [locationName, setLocationName] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.location &&
            reportListParameter?.location.length > 0
        ) {
            reportListParameter?.location?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setLocationName(data);
    }, [reportListParameter]);

    const updateLocationName = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...locationName]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setLocationName(storeData);
    }

    //upload image 
    const [filePreviews, setFilePreviews] = useState<Array<string[]>>([]);

    const handleFileUpload = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews = [...filePreviews];
            if (!updatedFilePreviews[index]) {
                updatedFilePreviews[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews((prevPreviews) => {
                    const updatedPreviews = [...prevPreviews];
                    updatedPreviews[index] = [base64Preview];
                    return updatedPreviews;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };



    //graph 0
    const [jakgraph, setjakGraph] = useState<any>([]);
    useEffect(() => {
        const Jakgraph: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image
            &&
            reportListParameter?.graph_image
                ?.length > 0
        ) {
            reportListParameter?.graph_image
                ?.map((list: any) => {
                    Jakgraph?.push({ ...list });
                });
        }
        setjakGraph(Jakgraph);
    }, [reportListParameter]);

    const updateGraphData = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...jakgraph]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setjakGraph(storeData);
    }

    //upload image 
    const [filePreviews1, setFilePreviews1] = useState<Array<string[]>>([]);

    const handleFileUpload1 = (files: any, index: any, list: any) => {
        const reader = new FileReader();

        reader.onload = () => {
            const fileContent = reader.result as string;
            const base64Image = fileContent.split(',')[1]; // Extract the base64 content

            // Add a file extension to base64Image
            const extension = 'jpg'; // Specify the desired file extension
            const base64ImageWithExtension = `data:image/${extension};base64,${base64Image}`;

            updateGraphData1(list?.id, base64ImageWithExtension, index, 'free_text', list);

            // Update the file preview for the current index
            const updatedFilePreviews = [...filePreviews];
            if (!updatedFilePreviews[index]) {
                updatedFilePreviews[index] = []; // Initialize the array if it doesn't exist for the current index
            } else {
                updatedFilePreviews[index] = []; // Clear the previous file preview for the current index
            }

            // Create a base64 preview for display
            const readerForPreview = new FileReader();
            readerForPreview.onloadend = () => {
                const base64Preview = readerForPreview.result as string;
                setFilePreviews1((prevPreviews) => {
                    const updatedPreviews = [...prevPreviews];
                    updatedPreviews[index] = [base64Preview];
                    return updatedPreviews;
                });
            };
            readerForPreview.readAsDataURL(files[0]);
        };

        reader.readAsDataURL(files[0]);
    };

    //graph 1
    const [jakgraph1, setjakGraph1] = useState<any>([]);
    useEffect(() => {
        const Jakgraph1: any = [];
        if (
            reportListParameter &&
            reportListParameter?.graph_image1 &&
            reportListParameter?.graph_image1?.length > 0
        ) {
            reportListParameter?.graph_image1?.map((list: any) => {
                Jakgraph1?.push({ ...list });
            });
        }
        setjakGraph1(Jakgraph1);
    }, [reportListParameter]);

    const updateGraphData1 = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...jakgraph1]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setjakGraph1(storeData);
    }

    // Hospital Id

    const [HospitalId, setHospitalId] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.Hospital_Id
            &&
            reportListParameter?.Hospital_Id

                .length > 0
        ) {
            reportListParameter?.Hospital_Id

                ?.map((list: any) => {
                    data?.push({ ...list });
                });
        }
        setHospitalId(data);
    }, [reportListParameter]);

    const updateHospitalID = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...HospitalId]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setHospitalId(storeData);
    }


    //doctor list
    const [jakdoctorList, setjakdoctorList] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.doctor_list &&
            reportListParameter?.doctor_list.length > 0
        ) {
            reportListParameter?.doctor_list?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setjakdoctorList(data);
    }, [reportListParameter]);

    const updateDoctorList = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...jakdoctorList]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setjakdoctorList(storeData);
    }


    //Sample Type
    const [sampletype, setsampletype] = useState<any>([]);
    useEffect(() => {
        const data: any = [];
        if (
            reportListParameter &&
            reportListParameter?.sample_type &&
            reportListParameter?.sample_type.length > 0
        ) {
            reportListParameter?.sample_type?.map((list: any) => {
                data?.push({ ...list });
            });
        }
        setsampletype(data);
    }, [reportListParameter]);

    const updateSampletype = (id: number, value: any, index: number, key: string, object: any) => {
        let storeData = [...sampletype]
        let newItem = object;
        switch (key) {
            case "free_text":
                newItem.parameter_value = value;
                break;
        }
        storeData[index] = newItem;
        setsampletype(storeData);
    }


    //Submit Data

    const submitData = async (e: any) => {
        e.preventDefault();

        let storeData: any = [];

        if (jakReport.length > 0) {
            jakReport?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (jakClinData.length > 0) {
            jakClinData?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (hospitalName.length > 0) {
            hospitalName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }



        // if (jakSignificance.length > 0) {
        //     jakSignificance?.map((list: any) => {
        //         storeData.push({
        //             ...list,
        //         });
        //     });
        // }
        if (jakMethology.length > 0) {
            jakMethology?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        if (Limitations.length > 0) {
            Limitations?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (textDetail.length > 0) {
            textDetail?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (jakgraph.length > 0) {
            jakgraph?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (jakgraph1.length > 0) {
            jakgraph1?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (jakdoctorList.length > 0) {
            jakdoctorList?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (jak.length > 0) {
            jak?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (HospitalId.length > 0) {
            HospitalId?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (clinicianName.length > 0) {
            clinicianName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        if (sampletype.length > 0) {
            sampletype?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }

        const stringify = JSON.stringify(tableData);
        if (jakResult.length > 0) {
            jakResult?.map((list: any) => {
                storeData.push({
                    ...list,
                    parameter_value: stringify,
                });
            });
        }
        if (locationName.length > 0) {
            locationName?.map((list: any) => {
                storeData.push({
                    ...list,
                });
            });
        }
        const reportData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            template_parameter: storeData,
            dob: dob,
            status: status,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };
        const reportEditData = {
            template_id: secondP,
            booking_id: firstP,
            case_id: firstP,
            status: status,
            template_parameter: storeData,
            dob: dob,
            customer_age: age,
            collection_date: Sample_Collected,
            pickup_date: Sample_Received,
            pickup_time: Sample_Receivedtime,
            customer_gender: Gender,
            customer_name: Name,
            designation: designation,
        };

        if (thirdP === "add") {
            await createNewReport(reportData);
            navigator('/dashboard/la');
        } else if (thirdP === "edit") {
            await updateReport(reportListParameter?.id, reportEditData);
            if (thirdP === "edit") {
                if (dob || age || Sample_Collected || Sample_Received || Sample_Receivedtime || Gender || designation || Name || status) {
                    await updateNiptDob(reportListParameter?.id, { dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status });
                } else {
                    console.error("Missing dob value for updateNiptDob");
                }
            } else {
                await createNiptDob(reportListParameter?.id, {
                    dob, age, Sample_Collected, Sample_Received, Sample_Receivedtime, Gender, designation, Name, status
                });
            }
        }
    };

    const [isInputFocused, setInputFocused] = useState(false);

    const handleInputFocus = () => {
        setInputFocused(true);
    };

    const handleInputBlur = () => {
        setInputFocused(false);
    };

    const [uhid, setuhid] = useState<any>([]);
    const [tempCode, setTempCode] = useState<any>([]);
    useEffect(() => {
        setuhid(reportListParameter?.uhid)
        setTempCode(reportListParameter?.template_code)
    }, [reportListParameter])
    const documentTitle = `${jakReport[0]?.pk}_${Name?.replace(/[\/\s]/g, '_')}_${uhid}_${tempCode}`;


    console.log(jakReport[0]?.uuid,"osaixsoixsoxi")

    return (
        <Grammarly clientId="client_6FRQR4cCPSqwqzYEfgQCbq">
            <div style={{ margin: "55px auto" }}>
                <div>
                    <div style={{ height: "20px" }}>
                        <div>
                            {thirdP !== "add" && (
                                <ReactToPrint
                                    content={reactToPrintContent}
                                    trigger={reactToPrintTrigger}
                                    documentTitle={documentTitle}
                                />
                            )}
                        </div>
                    </div>
                    <div style={{ width: "200px", marginLeft: "780px" }}>
                        <TextField
                            id="outlined-select-currency"
                            select
                            variant="outlined"
                            fullWidth
                            className={classes.input}
                            label="Select Report Type"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            style={{ height: "30px" }}
                        >
                            <MenuItem value={"Draft"}>Draft</MenuItem>
                            <MenuItem value={"Editable"}>Editable</MenuItem>
                            <MenuItem value={"Approved"}>Approved</MenuItem>
                            <MenuItem value={"Hold"}>Hold</MenuItem>
                            <MenuItem value={"Cancelled"}>Cancelled</MenuItem>
                        </TextField>
                    </div>

                    <div style={{ height: "20px", marginLeft: "1000px", marginBottom: "20px" }}>
                        <div>
                            <button style={{ background: "#142c96", color: "white", width: "100px", height: "40px", marginTop: "-10px" }} disabled={status === ""} onClick={submitData}>Submit</button>
                        </div>
                    </div>
                </div>
                <div
                    id="PAGE"
                    ref={componentRef}
                    style={{
                        width: 1122,
                        background: "#fff",
                    }}
                >
                    {/* header section */}
                    <div className="page-header">
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "80%", padding: 15 }}>
                                    <div
                                        style={{
                                            color: "#1A5276",
                                            fontWeight: "bold",
                                            fontSize: "30px",
                                            textAlign: "left",
                                        }}
                                    >
                                        LABORATORY REPORT
                                    </div>
                                </div>
                                <div style={{ width: "20%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <img src={logo} alt="logo" style={{ width: "200px" }} />
                                    </h3>
                                </div>
                                <div style={{ width: "15%", textAlign: "left", padding: 0 }}>
                                    <h3>
                                        <img src={mra} alt="logo" style={{ width: "106px" }} />
                                    </h3>
                                </div>
                                {/* <div  style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                    <div style={{ width: "13%", textAlign: "left", padding: 0 }}>
                                        <h3>
                                            <img src={nabllogo} alt="logo" style={{ width: "75px" }} />
                                        </h3>
                                    </div>
                                    <div style={{ textAlign: "center", marginTop: "10px" }}>
                                        <p style={{ fontSize: "16px", color: "#333", fontWeight: "bold",width:"80px" }}>MC-5280</p>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="main-contain-section"> */}
                    <div className="main-content3">.</div>
                    <div
                        style={{
                            fontSize: "25px",
                            // color: "#73016d",
                            textAlign: "center",
                            marginBottom: "20px"
                        }}
                    >
                        <span style={{ fontWeight: "bold", color: "#750b1e" }}>JAK2</span> <span style={{ fontWeight: "bold", color: "#750b1e" }}>V617F MUTATION DETECTION, RTPCR</span>
                    </div>

                    {/* patient details page 1 */}
                    <Paper style={{ backgroundColor: "#F8F8F8", width: "96%", marginLeft: "25px", marginTop: "10px" }}>
                        <Grid container spacing={2} style={{ fontWeight: "bold", fontSize: "15px", marginTop: "-20px" }} className="marginLeft-c">
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient ID
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {jakReport[0]?.pk
                                                ? jakReport[0]?.pk
                                                : "NA"}
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                        <Grid item xs={3.5}>
                                            Patient Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :  <input
                                                className="input"

                                                style={{ border: "none", width: designation ? `${(designation.length + 1) * 8}px` : "20px", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}

                                                type="text"
                                                value={designation}
                                                onChange={(e) => setdesignation(e.target.value)}
                                            />
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "70%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                value={Name}
                                                onChange={(e) => setName(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <Grid item xs={3.5}>
                                            Patient DOB
                                        </Grid><Grid item xs={8.5}>
                                            : <input
                                                className="input"
                                                style={{ border: "none", width: "65%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                type="text"
                                                value={dob}
                                                placeholder={isInputFocused ? 'YYYY-MM-DD' : 'NA'}
                                                onChange={(e) => {
                                                    setDob(e.target.value);
                                                }}
                                                onFocus={handleInputFocus}
                                                onBlur={handleInputBlur} />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>

                                        <>
                                            <Grid item xs={3.5}>
                                                Age
                                            </Grid>
                                            {dob === "" || dob === null ? (
                                                <Grid item xs={8.5}>
                                                    :  <input
                                                        className="input"
                                                        style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}
                                                        type="text"
                                                        value={age}
                                                        onChange={(e) => setAge(e.target.value)} />Y
                                                </Grid>
                                            )
                                                : (
                                                    <Grid item xs={8.5} style={{ border: "none", width: "12%", textAlign: "start", appearance: "none", background: "none", marginLeft: "2px", fontWeight: "bold" }}>
                                                        : {age} Y
                                                    </Grid>
                                                )}
                                        </>
                                    </div>
                                </Grid>
                                {/* <Grid item xs={12}>
                                    {jakReport[0]?.center?.name && jakReport[0]?.center?.name.toUpperCase().includes("ARMC") ? (
                                        <div style={{ width: "100%", display: "flex", margin: "8px 5px" }}>
                                            <Grid item xs={3.5}>
                                                Hospital ID
                                            </Grid>
                                            <Grid item xs={8.5}>
                                                : {HospitalId?.map((list: any, index: number) => {
                                                    return (
                                                        <input
                                                            key={list?.id}
                                                            style={{ border: "none", width: "96%", background: "none", fontWeight: "bold" }}
                                                            value={list?.parameter_value}
                                                            onChange={(e: any) => updateHospitalID(list?.id, e.target.value, index, "free_text", list)}
                                                        />
                                                    );
                                                })}
                                            </Grid>
                                        </div>
                                    ) : null}
                                </Grid> */}
                            </Grid>
                            {/* rest half page---------------------------> */}
                            <Grid item xs={4.6}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Gender
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            :  <input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                value={Gender}
                                                onChange={(e) => setGender(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Clinician Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {clinicianName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateClinicanName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Location
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {locationName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateLocationName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={3.5}>
                                            Hospital Name
                                        </Grid>
                                        <Grid item xs={8.5}>
                                            : {hospitalName?.map((list: any, index: number) => {
                                                return (
                                                    <input style={{ border: "none", width: "97%", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e: any) => updateHospitalName(list?.id, e.target.value, index, "free_text", list)} />
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                            {/* 3rd half  */}
                            <Grid item xs={3.4}>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Type
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {sampletype?.map((list: any, index: number) => {
                                                return (
                                                    <select name="sample" id="1" style={{ border: "none", WebkitAppearance: "none", background: "none", fontWeight: "bold" }} value={list?.parameter_value} onChange={(e) => updateSampletype(list?.id, e.target.value, index, "free_text", list)}>
                                                        <option value="normal">NA</option>
                                                        <option value="EDAT">Amniotic Fluid </option>
                                                        <option value="Venous">Chorionic Villi </option>
                                                        <option value="Arterial">Fetal Cord Blood</option>
                                                        <option value="Abortus">Product of Conception</option>
                                                        <option value="Placenta">Placenta</option>
                                                        <option value="Fetal">Fetal Cord (PUBS)</option>
                                                        <option value="Peripheral">Peripheral Blood</option>
                                                        <option value="Peripheral1">Pre Natal Cord </option>
                                                        <option value="dna">DNA</option>
                                                        <option value="blood">Blood</option>
                                                        <option value="whole blood edta"> Whole Blood EDTA </option>
                                                        <option value="ffpe tissue block"> FFPE TISSUE BLOCK </option>
                                                        <option value="Bone Marrow">Bone Marrow</option>
                                                    </select>
                                                )
                                            })
                                            }
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Collected
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            :<input
                                                className="input"
                                                style={{ border: "none", width: "75%", textAlign: "start", appearance: "none", fontWeight: "bold", background: "none" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                pattern="\d{4}-\d{2}-\d{2}"
                                                value={Sample_Collected}
                                                onChange={(e) => setSample_Collected(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Sample Received
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            :<input
                                                className="input"
                                                style={{ border: "none", width: "52%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="yyyy-mm-dd"
                                                value={Sample_Received}
                                                onChange={(e) => setSample_Received(e.target.value)}
                                            />,
                                            <input
                                                className="input"
                                                style={{ border: "none", width: "40%", textAlign: "start", appearance: "none", background: "none", fontWeight: "bold" }}
                                                type="text"
                                                placeholder="HH:MM:SS"
                                                value={Sample_Receivedtime}
                                                onChange={(e) => setSample_Receivedtime(e.target.value)}
                                            />
                                        </Grid>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div style={{ width: "100%", display: "flex", margin: "8px 0px" }}>
                                        <Grid item xs={5.1}>
                                            Report Released
                                        </Grid>
                                        <Grid item xs={6.9}>
                                            : {moment.tz(Date.now(), "Asia/Kolkata").format("YYYY-MM-DD,HH:mm:ss")}
                                        </Grid>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>
                    <div style={{ width: "96%", marginLeft: "25px" }}>
                        <h6 style={{ backgroundColor: "rgb(22 55 88)", color: "white", textAlign: "center", borderBottomLeftRadius: "15px", borderBottomRightRadius: "15px", height: "35px", marginTop: "-1px", padding: "8px" }}>Test Requested:-{jakReport[0]?.packages[0]?.name}</h6>
                    </div>
                    <div className="br">.</div>

                    {/* clinical indication  */}
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 43px", fontSize: "17px" }}> CLINICAL INDICATION </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {jakClinData?.map((list: any, index: number) => {
                            return (
                                <div style={{ padding: 15, textAlign: "left", marginTop: "-7px", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", marginLeft: "32px", fontSize: "14px" }}
                                            rows={3}
                                            cols={100}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateClientIndication(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            )
                        })}
                    </div>

                    {/* results  */}
                    <div>
                        <h4 style={{ color: "rgb(28, 78, 128)", marginLeft: "45px", fontSize: "17px" }}>
                            RESULTS SUMMARY
                        </h4>
                    </div>
                    <div>
                        <div className="contain" style={{ border: "2px solid rgb(38, 31, 87)", width: "94%", marginLeft: '40px' }} >
                            {tableData?.length > 0 &&
                                tableData?.map((list: any, index: number) => {
                                    return (
                                        <>
                                            <div
                                                style={{
                                                    width: "100%",
                                                    display: "flex",
                                                    margin: "10px 0px",
                                                    fontSize: "14px",
                                                    height: "40px",
                                                }}
                                                className={index % 2 === 0 ? 'even-row' : 'odd-row'}
                                            >
                                                <div style={{ width: "40%", marginLeft: 8 }}>
                                                    <GrammarlyEditorPlugin>
                                                        <input
                                                            style={{ border: "none", width: "90%", background: "none", marginLeft: "20px", marginTop: "7px" }}
                                                            value={list?.name}
                                                            onChange={(e: any) =>
                                                                updateRow(index, "name", e.target.value, list)
                                                            }
                                                        />
                                                    </GrammarlyEditorPlugin>
                                                </div>
                                                <div style={{ marginTop: "7px" }}> :</div>
                                                {list?.risk !== "green" ?
                                                    <div
                                                        style={{ width: "45%", marginLeft: 8, textAlign: "left" }}
                                                    >
                                                        <GrammarlyEditorPlugin>
                                                            <input
                                                                style={{ border: "none", width: "100%", fontWeight: "bold", background: "none", marginTop: "7px" }}
                                                                value={list?.result}
                                                                onChange={(e: any) =>
                                                                    updateRow(index, "result", e.target.value, list)
                                                                }
                                                            />
                                                        </GrammarlyEditorPlugin>
                                                    </div> :
                                                    <div
                                                        style={{ width: "45%", marginLeft: 8, textAlign: "left" }}
                                                    >
                                                    </div>
                                                }
                                            </div>

                                        </>
                                    );
                                })}

                        </div>
                    </div>

                    {/* Clinical Significance */}
                    <div className="br">.</div>
                    <div className="clinical__indicatio">
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            CLINICAL SIGNIFICANCE
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ width: "93%", marginLeft: "40px", fontSize: "14px" }}>
                        {/* <p>
                            JAK2 V617F mutations accounts for 90% PV patients and 60% of ET or MF patients. Rare Exon 12 insertion and deletion mutations in JAK2
                            accounts for 2-3% of PV. For the diagnosis of PV and ET three major criteria are defined of which one is the mutation in exon 12 or 14
                            (V617F) of JAK2 gene for PV and mutation in either JAK2, CALR or MPL gene for ET.
                        </p> */}
                        <p >
                            Janus kinase 2 gene (JAK2) codes for a Tyrosine kinase (JAK2) that is associated with the cytoplasmic portion of a variety of trans-membrane cytokines and growth factor
                            receptors important for signal transduction in hematopoietic cells. JAK2 V617F mutations accounts for 90% PV patients and 60% of ET or MF patients. Rare Exon 12
                            insertion and deletion mutations in JAK2 accounts for 2-3% of PV. For the diagnosis of PV and ET three major criteria are defined of which one is the mutation in exon
                            12 or 14 (V617F) of JAK2 gene for PV and mutation in either JAK2, CALR or MPL gene for ET.
                        </p>
                        <p >
                            PV Patients with JAK2 exon 12 mutation have younger age, increased mean hemoglobin/hematocrit, and lower WBC & platelets count at
                            diagnosis compared to those with JAK2 V617F mutation. However both JAK2 mutations are associated with similar rates of thrombosis,
                            evolution to myelofibrosis or leukemia and death.
                        </p>
                        <p >
                            ET patients with ≤60 years and JAK2 mutation are at low risk with no prior history of thrombosis and the patients with history of thrombosis
                            at any age with JAK2 mutation are at high risk. Patients with PMF having JAK2 V617F mutation are at intermediate prognosis and higher
                            risk of thrombosis compared to patients with CALR mutations. Triple negative patients with PMF have inferior leukemia free survival
                            compared to patients with JAK2 and/or CALR mutated and inferior overall survival compared to patients with CALR mutated patients.
                            {/* Kindlycorrelate clinically. */}
                        </p>
                        <p>
                            Diagnostic criteria for ET, MF and PV adopted by the World Health Organization (WHO) include identification of a clonal marker to test for the JAK2 V617F
                            mutation in exon14. In JAK2 V617F negative patients, the presence of JAK2 exon 12 mutations also meets the WHO criterion for establishing clonality. In rare
                            cases, JAK2 mutation is found in exon 13. PV, ET and PMF are BCR-ABL1-negative Myeloproliferative neoplasms (MPN) frequently showing a single nucleotide
                            mutation in JAK2 characterized as c.G1849T; p.Val617Phe (V617F).
                        </p>
                    </div>

                    {/* <div className="br">.</div> */}
                    {/* <div className="pmain-content5">.</div> */}
                    {/* doctor sign  */}
                    {/* <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "40px" }}>
                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div> */}
                    {/* static data  */}
                    {/* <div className="main-content3">.</div>
                    <div className="main-content3">.</div>
                    <div className="br1">.</div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{jakReport[0]?.designation}&nbsp;{jakReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{jakReport[0]?.pk}
                    </div> */}
                    <div >
                        <img src={graph} alt="graph" style={{ width: "100%", height: "335px" }} />
                    </div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="br">.</div>
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px", fontSize: "17px" }}
                        >
                            RECOMMENDATION
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div style={{ fontSize: "14px", marginLeft: "20px", width: "96%" }}>
                        <ol>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Please correlate with clinical features and other investigations for final conclusion and send a repeat sample for analysis if necessary.
                                </p>
                            </li>
                            <li>
                                <p>
                                    For about this report, or for assistance in locating nearby genetic counselling services, please contact the Laboratory; geneticcounsellors@redcliffelabs.com, or
                                    ccsupport@redcliffelabs.com.
                                </p>
                            </li>
                        </ol>
                    </div>
                    <div className="clinical__indicatio" >
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px", fontSize: "17px" }}
                        >
                            METHODOLOGY
                        </span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div>
                        {jakMethology.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            style={{ border: "none", resize: "none", fontSize: "14px" }}
                                            rows={4}
                                            cols={112}
                                            value={list?.parameter_value}
                                            onChange={(e) => updateMethology(list?.id, e.target.value, index, "free_text", list)}
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    {/* upload image  */}
                    {/* <div style={{ display: "flex", marginTop: "-30px" }}>
                        <>
                            <div>
                                {jakgraph.map((list: any, index: number) => {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "90%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}
                                        >
                                            Display base64-encoded image
                                            {
                                                thirdP === 'edit' && list.parameter_type === 'free_text' && list.parameter_name === 'graph_image3' && list.parameter_value && list.parameter_value.startsWith('data:image/') && (
                                                    <div>
                                                        <img
                                                            src={list.parameter_value}
                                                            alt={`Image ${index}`}
                                                            style={{ width: '100%', maxHeight: "1200px" }}
                                                        />
                                                    </div>
                                                )
                                            }
                                            Display file previews
                                            {index === 0 && filePreviews[index] && (
                                                <div>
                                                    {filePreviews[index].map((preview: string, previewIndex: number) => (
                                                        <img
                                                            key={previewIndex}
                                                            src={preview}
                                                            alt={`File Preview ${previewIndex + 1}`}
                                                            style={{ width: "100%", maxHeight: "1200px" }}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                })}
                            </div>
                            <div>
                                {jakgraph1.map((list: any, index: number) => {
                                    return (
                                        <div
                                            key={index}
                                            style={{ width: "90%", padding: 15, textAlign: "left", fontSize: "14px", marginLeft: "35px" }}
                                        >
                                            Display base64-encoded image
                                            {
                                                thirdP === 'edit' && list.parameter_type === 'free_text' && list.parameter_name === 'graph_image4' && list.parameter_value && list.parameter_value.startsWith('data:image/') && (
                                                    <div>
                                                        <img
                                                            src={list.parameter_value}
                                                            alt={`Image ${index}`}
                                                            style={{ width: '100%', maxHeight: "1200px" }}
                                                        />
                                                    </div>
                                                )
                                            }
                                            Display file previews
                                            {index === 0 && filePreviews1[index] && (
                                                <div>
                                                    {filePreviews1[index].map((preview: string, previewIndex: number) => (
                                                        <img
                                                            key={previewIndex}
                                                            src={preview}
                                                            alt={`File Preview ${previewIndex + 1}`}
                                                            style={{ width: "100%", maxHeight: "1200px" }}
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                            {thirdP === "edit" ? "" :
                                                <input
                                                    type="file"
                                                    onChange={(e) => handleFileUpload1(e.target.files, index, list)}
                                                />}
                                        </div>
                                    );
                                })}
                            </div>
                        </>
                    </div> */}
                    {/* <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div> */}
                    {/* <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div> */}
                    {/* <div className="main-content2">.</div> */}
                    {/* <div className="main-content3">.</div> */}
                    {/* <div className="br1">.</div>
                    <div
                        style={{
                            fontWeight: "bold",
                            fontSize: "15px",
                            borderTopRightRadius: "20px",
                            borderBottomRightRadius: "20px",
                            background: "rgb(238, 238, 238)",
                            textAlign: "left",
                            marginTop: "20px",
                            width: "700px",
                            height: "40px",
                            padding: "10px",
                            paddingLeft: "40px",
                            borderRight: "1px solid rgb(22 55 88)",
                            borderBottom: "1px solid rgb(22 55 88)",
                            borderTop: "1px solid rgb(22 55 88)"
                        }}
                        className="marginleft-b">
                        Patient Name:&nbsp;&nbsp;{jakReport[0]?.designation}&nbsp;{jakReport[0]?.customer_name}
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        Patient Id:&nbsp;&nbsp;{jakReport[0]?.pk}
                    </div> */}


                    {/* <div className="br">.</div> */}

                    {/* test details */}
                    {/* <br /> */}
                    <div className="clinical__indicatio">
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px", fontSize: "17px" }}
                        >
                            {/* Test Details */}
                            TEST DETAILS & LIMITATIONS
                        </span>

                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />
                    <div className="contain" style={{ border: "none", width: "90%", marginLeft: "40px", backgroundColor: "white", padding: 8 }}>

                        {textDetail?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={100}
                                            rows={3}
                                            style={{ border: "none", resize: "none", fontSize: "14px" }}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updatetextDetail(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div
                        className="contain"
                        style={{ border: "none", width: "92%", marginLeft: "40px", backgroundColor: "white", padding: 8 }}
                    >

                        {Limitations?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={133}
                                            rows={5}
                                            style={{ border: "none", resize: "none" }}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateLimitations(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div>
                    <div style={{ fontSize: "14px", marginLeft: "20px", width: "96%" }}>
                        <ol>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    Test results obtained are based on the sample type and depends on the quality of the sample received.
                                    Test results should be clinically correlated to arrive at a diagnosis and therapy decision.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    This test was performed on Real time PCR. This test does not detect JAK2 Mutant allele burden of 1 percent. The JAK2 V617F mutation with an allele burden
                                    of 1 percent is a normal variant in a subgroup of individuals and is not clinically significant for diagnosis of Myeloproliferative neoplasms.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                 There is possibility of presence of PCR inhibitors (cannot be traced by technologist) or in rare cases, a mutation other than the V617F which can be present in an
                                    area that interferes with primer binding and cause a false-negative result. There is possibility of background DNA contamination resulting from a pre- analytical
                                    issue or from in lab environment which may result in false-positive report.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    This test was developed and its analytical performance characteristics have been determined by Redcliffe labs which is used for clinical diagnosis. This test is
                                    under NABL scope accreditation.
                                </p>
                            </li>
                            <li>
                                <p style={{marginBottom:"0px"}}>
                                    All precautions were taken to ensure the accuracy of test results. Although molecular testing is highly accurate, rarely false-positive and false-negative diagnostic errors may occur.
                                </p>
                            </li>
                        </ol>
                    </div>

                    <div className="br">.</div>
                    {/* limitations of assay  */}
                    {/* <div className="clinical__indicatio">
                        <span
                            className="clinical__subheadin"
                            style={{ padding: "0px 10px 0px 45px" }}
                        >
                            Limitation of assay -
                        </span>

                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} /> */}

                    {/* <div
                        className="contain"
                        style={{ border: "none", width: "92%", marginLeft: "40px", backgroundColor: "white", padding: 8 }}
                    >

                        {Limitations?.map((list: any, index: number) => {
                            return (
                                <div style={{ width: "100%", fontSize: "15px" }}>
                                    <GrammarlyEditorPlugin>
                                        <textarea
                                            cols={133}
                                            rows={5}
                                            style={{ border: "none", resize: "none" }}
                                            value={list?.parameter_value}
                                            onChange={(e) =>
                                                updateLimitations(
                                                    list?.id,
                                                    e.target.value,
                                                    index,
                                                    "free_text",
                                                    list
                                                )
                                            }
                                        />
                                    </GrammarlyEditorPlugin>
                                </div>
                            );
                        })}
                    </div> */}
                    {/* <div style={{ fontSize: "14px", marginLeft: "20px", width: "96%" }}>
                        <ol>
                            <li>
                                <p>
                                    Test results obtained are based on the sample type and depends on the quality of the sample received.
                                    Test results should be clinically correlated to arrive at a diagnosis and therapy decision.
                                </p>
                            </li>
                            <li>
                                <p>
                                    This test was performed on Real time PCR. This test does not detect JAK2 Mutant allele burden of 1 percent. The JAK2 V617F mutation with an allele burden
                                    of 1 percent is a normal variant in a subgroup of individuals and is not clinically significant for diagnosis of Myeloproliferative neoplasms.
                                </p>
                            </li>
                            <li>
                                <p>
                                    There is possibility of presence of PCR inhibitors (cannot be traced by technologist) or in rare cases, a mutation other than the V617F which can be present in an
                                    area that interferes with primer binding and cause a false-negative result. There is possibility of background DNA contamination resulting from a pre- analytical
                                    issue or from in lab environment which may result in false-positive report.
                                </p>
                            </li>
                            <li>
                                <p>
                                    This test was developed and its analytical performance characteristics have been determined by Redcliffe labs which is used for clinical diagnosis. This test is
                                    under NABL scope accreditation.
                                </p>
                            </li>
                            <li>
                                <p>
                                    All precautions were taken to ensure the accuracy of test results. Although molecular testing is highly accurate, rarely false-positive and false-negative diagnostic errors may occur.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Test results should be clinically correlated to arrive at a diagnosis and therapy decision.
                                </p>
                            </li>
                            <li>
                                <p>
                                    PCR is a highly sensitive technique, common reasons for paradoxical results are contamination during specimen collection, selection of inappropriate specimen and inherent PCR inhibitors in the sample.
                                </p>
                            </li>
                            <li>
                                <p>Repeats are accepted on request of Referring Physician within 7 days post reporting.</p>
                            </li>
                            <li>
                                <p>
                                    Test results are not valid for any medico legal purposes.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Report with status “Preliminary” means one or more test are yet to be reported.
                                </p>
                            </li>
                        </ol>
                    </div> */}

                    {/* <div style={{ fontSize: "20px", fontWeight: "bold", color: "darkblue", width: "93%", marginLeft: "30px" }}>
                        <p>
                            Applicable Jurisdiction will be of Delhi & for any dispute/claim concerning the test(s) & results of the test
                        </p>
                    </div> */}


                    {/* <div className="br">.</div> */}
                    <div className="clinical__indicatio" >
                        <span className="clinical__subheadin" style={{ padding: "0px 10px 0px 45px", fontSize: "17px" }}>DISCLAIMER</span>
                    </div>
                    <hr style={{ border: "1px solid rgb(184, 168, 167)", width: '93%' }} />

                    <div className="contain" style={{ border: "none", width: "96%", backgroundColor: "white", marginLeft: "45px", fontSize: "14px" }}>
                        <br />
                        <ul>
                            <li>
                                <p>Test results released pertain to the specimen submitted .</p>
                            </li>
                            <li>
                                <p>
                                    All test results are dependent on the quality of the sample
                                    received by the Laboratory .
                                </p>
                            </li>
                            <li>
                                <p>
                                    Laboratory investigations are only a tool to facilitate in
                                    arriving at a diagnosis and should be clinically correlated by
                                    the Referring Physician .
                                </p>
                            </li>
                            <li>
                                <p>
                                    Certain tests may require further testing at additional cost
                                    for derivation of exact value. Kindly submit request within 72
                                    hours post reporting.
                                </p>
                            </li>
                            <li>
                                <p>Test results may show inter laboratory variations in case of certain factor.</p>
                            </li>
                            {/* <li>
                                <p>
                                    If Sample collection date is not stated on test requisition
                                    form, the current date will be printed by default as the date
                                    of collection.
                                </p>
                            </li> */}
                            <li>
                                <p>Test results are not valid for medico legal purposes.</p>
                            </li>
                        </ul>
                    </div>
                    <div style={{display:"flex",justifyContent:"center"}}>
                        <b>
                        -------End Of Report------
                        </b>
                    </div>
                    {/* doctor sign  */}
                    <div style={{ width: "89%", display: 'flex', padding: 0, margin: 0, justifyContent: 'space-around', marginTop: "30px" }}>
                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <img
                                        alt="description of image"
                                        style={{ width: "100px", height: "50px", marginLeft: "80px" }}
                                        src={list?.parameter_url}
                                    />
                                </>
                            )
                        })}
                    </div>
                    <div style={{ width: "97%", display: 'flex', alignItems: 'left', marginLeft: "10px" }}>

                        {jakdoctorList && jakdoctorList?.length > 0 && jakdoctorList?.filter((doctor:any)=> doctor?.parameter_url !== "")?.map((list: any, index: number) => {
                            return (
                                <>
                                    <textarea
                                        style={{ border: "none", resize: "none", textAlign: "center" }}
                                        rows={4}
                                        cols={140}
                                        value={list?.parameter_value}
                                        onChange={(e) => updateDoctorList(list?.id, e.target.value, index, "free_text", list)}
                                    />
                                </>
                            )
                        })}
                    </div>

                    {/* footer section starting */}
                    <div className="page-footer">
                        {/* footer area */}
                        <div style={{ padding: "20px" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    background: "#fff",
                                }}
                            >
                                <div style={{ width: "15%", textAlign: "left", padding: 15 }}>
                                    <h3>
                                        <QRCode value={`https://lead.redcliffelabs.com/verify-report/?booking=${uuid}&api_key=pvkbv24f916fa28-dd38-4ba5-ad6c-8a78d0`} size={110} />
                                    </h3>
                                </div>
                                <div
                                    style={{
                                        width: "85%",
                                        textAlign: "left",
                                        padding: 10,
                                        marginTop: "-3px",
                                    }}
                                >
                                    <div
                                        style={{ width: "100%", display: "flex", margin: "10px 0px" }}
                                    >
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={callIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />{" "}
                                            <span style={{ color: "red" }}>
                                                <b>931-126-1989</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: 8 }}>
                                            <img
                                                src={maillIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>geneticcounselors@redcliffelabs.com</b>
                                            </span>
                                        </div>
                                        <div style={{ width: "33%", marginLeft: "68px" }}>
                                            <img
                                                src={browserIcon}
                                                alt="logo"
                                                style={{ width: "20px", margin: "2px" }}
                                            />
                                            <span style={{ color: "red" }}>
                                                <b>www.redcliffelabs.com</b>
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <h5 style={{ marginLeft: "16px" }}>
                                            {" "}
                                            <b>
                                                Redcliffe Lifetech Pvt. Ltd, H-31, Sector- 63, Noida,
                                                Uttar Pradesh, 201301
                                            </b>
                                        </h5>
                                    </div>
                                    <div
                                        style={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "10px 0px",
                                            marginLeft: "16px",
                                            textAlign: "left",
                                        }}
                                    >
                                        <p style={{ fontSize: "13px", marginTop: "-8px" }}>
                                            {" "}
                                            All Lab are subjected to clinical interpretations by
                                            qualified medical professional and this report is not
                                            subject to use for any medico-legal purpose.
                                        </p>
                                    </div>
                                    <hr
                                        style={{
                                            backgroundColor: "red",
                                            width: "100%",
                                            height: "8px",
                                            marginTop: "10px",
                                        }}
                                        className="box"
                                    />
                                </div>
                            </div>
                        </div>
                        {/* footer area closed */}
                        
                    </div>

                    {
                        uuid && (
                            <div className="hide-section-rating">
                                <NpsRating bookingId={firstP} uuid={uuid} />
                            </div>
                        )
                    }
                </div>
            </div >
        </Grammarly >
    );
};

const mapStateToProps = (state: any) => ({
    reportListParameter: state.LimsAdminReducer.reportListParameter,
});

export default connect(mapStateToProps, {
    getReportTemplateParameter,
    createNewReport,
    updateReport,
    getUpdatedCustomerReportData,
    updateNiptDob,
    createNiptDob,
})(JakReport);

function setInputValues(arg0: (prevState: any) => any) {
    throw new Error("Function not implemented.");
}